import { jsx } from 'react/jsx-runtime';

const root = "_root_13vqo_1";
const styles = {
	root: root
};

const FormLabelRequiredText = ({ children = "Required", isDisabled = false }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    jsx("span", { "aria-hidden": "true", className: styles.root, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true, children })
  );
};

export { FormLabelRequiredText };
//# sourceMappingURL=FormLabelRequiredText.es.js.map
